import React, { useContext, useState } from 'react'
import { M_Table, LoadingContext, BufferService, NavigateContext } from 'src/M_Components'
import { useTranslation } from 'react-i18next'

export const ApproveQuoteList = ({ roles, tablesOrder = [], onTablesOrderUpdate }) => {
    const [refresh, setRefresh] = useState(false)
    const [selectedRows, setSelectedRows] = useState([])
    const bufferServiceQuote = new BufferService('Quote')
    const ctx = useContext(LoadingContext)
    const ctx2 = useContext(NavigateContext)
    const { t } = useTranslation()

    const NewRoute = (url, label, operation, data) => {
        const tempPerm = []

        roles.forEach((role) => {
            if (role.match('Quote')) {
                tempPerm.push(role.split('Quote')[1])
            }
        })

        let tempData = data ?? sessionStorage.getItem("context");
        if (tempData === "undefined") {
            ctx.toastMessages("error", "", t("SelectedLine"));
        return;
        }
        tempData = data ?? JSON.parse(tempData);
        sessionStorage.removeItem("context");

        ctx.passValue?.set('operation', operation)
        ctx.passValue?.set('Row', tempData)

        if (operation === 'view') {
            ctx2.newTab('go/approveQuoteDetail', t("CheckQuote") + ": " + tempData.Name)
            return
        }
    }

    const removeContextItems = ['View', 'Copy', 'Create', 'Edit', 'Delete']

    const getContextQuote = (e) => {
        if (e) {
            sessionStorage.setItem("context", JSON.stringify(e));
        } else {
            sessionStorage.removeItem("context");
        }
    };

    return (
        <div className='backgroundForms'>
            < div >
                <div>
                    <M_Table
                        roleName={'Quote'}
                        filtersOnTable
                        entityName={'quote'}
                        tablesOrder={tablesOrder}
                        onTablesOrderUpdate={onTablesOrderUpdate}
                        removeContextItems={removeContextItems}
                        refresh={refresh}
                        setRefresh={setRefresh}
                        rolePermissions={roles}
                        // replaceFunctions={new Map([
                        //     ['View', (data) => NewRoute('', '', 'view', data)]
                        // ])}
                        extraButtons={[{
                            label: t("CheckQuote"),
                            element: "default",
                            source: "/icons/svgsDaNet/search.svg",
                            style: {
                                filter:
                                    "invert(60%) sepia(93%) saturate(1397%) hue-rotate(169deg) brightness(83%) contrast(86%)",
                            },
                            command: (data) => NewRoute('', '', 'view', data),
                        }]}
                        lineContext={[{
                            label: t("CheckQuote"),
                            icon: "pi pi-search",
                            command: () => NewRoute('', '', 'view'),
                        }]}
                        onPassLine={(rows) => {
                            setSelectedRows(rows)
                        }}
                        onPassContext={(data) => getContextQuote(data)}
                        FILTER={"StatusValue eq 'W'"}
                    />
                </div>
                <div className='dividerTables'></div>
            </div>
        </div >
    )
}
